// kip theme JS — IM8 mechanics (AJAX cart drawer, plan selector, sticky buy bar), kip identity
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var routes = (window.kip && window.kip.routes) || { cart: '/cart', add: '/cart/add', change: '/cart/change', root: '/' };

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  function scrollBehavior() { return reduced.matches ? 'auto' : 'smooth'; }
  // One modal at a time: contain focus, isolate background, restore the opener.
  var modalState = null;
  window.kipModal = {
    open: function (root, opener) {
      if (modalState && modalState.root === root) return;
      if (modalState) window.kipModal.close(modalState.root);
      var changed = [], node = root;
      while (node && node.parentElement && node !== document.body) {
        Array.prototype.forEach.call(node.parentElement.children, function (el) {
          if (el !== node && !el.inert && el.tagName !== 'SCRIPT') { el.inert = true; changed.push(el); }
        });
        node = node.parentElement;
      }
      modalState = { root: root, opener: opener || document.activeElement, changed: changed };
      var focusable = root.querySelector('button, a[href], input, [tabindex="0"]');
      if (focusable) focusable.focus();
    },
    close: function (root) {
      if (!modalState || modalState.root !== root) return;
      var old = modalState; modalState = null;
      old.changed.forEach(function (el) { el.inert = false; });
      if (old.opener && old.opener.isConnected) old.opener.focus();
    }
  };
  document.addEventListener('keydown', function (e) {
    if (!modalState || e.key !== 'Tab') return;
    var list = $$('button:not(:disabled), a[href], input:not(:disabled), select, textarea, [tabindex="0"]', modalState.root)
      .filter(function (el) { return !el.closest('[hidden], [inert]') && el.getClientRects().length; });
    if (!list.length) { e.preventDefault(); return; }
    var first = list[0], last = list[list.length - 1];
    if (e.shiftKey && (document.activeElement === first || !modalState.root.contains(document.activeElement))) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && (document.activeElement === last || !modalState.root.contains(document.activeElement))) { e.preventDefault(); first.focus(); }
  });

  /* ---------- nav ---------- */
  var menuBtn = $('#menuBtn'), nav = $('#nav');
  function closeMenu(restoreFocus) {
    if (!menuBtn || !nav || !nav.classList.contains('mobile-open')) return;
    nav.classList.remove('mobile-open');
    menuBtn.setAttribute('aria-expanded', 'false');
    menuBtn.setAttribute('aria-label', 'Open menu');
    if (restoreFocus) menuBtn.focus();
  }
  if (menuBtn && nav) {
    menuBtn.addEventListener('click', function () {
      var open = nav.classList.toggle('mobile-open');
      menuBtn.setAttribute('aria-expanded', String(open));
      menuBtn.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    });
    $$('.nav-l a', nav).forEach(function (a) { a.addEventListener('click', function () { closeMenu(false); }); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeMenu(true); });
    document.addEventListener('click', function (e) {
      if (!nav.contains(e.target) || e.target.closest('[data-drawer-open]')) closeMenu(false);
    });
    document.addEventListener('focusin', function (e) { if (!nav.contains(e.target)) closeMenu(false); });
    var mobileNav = window.matchMedia('(max-width: 960px)');
    mobileNav.addEventListener('change', function () { if (!mobileNav.matches) closeMenu(false); });
  }

  /* ---------- voices carousel (homepage) ---------- */
  var vt = $('#vTrack'), vp = $('#vPrev'), vn = $('#vNext');
  if (vt && vp && vn) {
    vp.addEventListener('click', function () { vt.scrollBy({ left: -380, behavior: scrollBehavior() }); });
    vn.addEventListener('click', function () { vt.scrollBy({ left: 380, behavior: scrollBehavior() }); });
  }

  /* ---------- scroll reveal ---------- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { threshold: 0 });
    $$('.reveal').forEach(function (el) { io.observe(el); });
  } else { $$('.reveal').forEach(function (el) { el.classList.add('in'); }); }
  /* ---------- qty steppers (PDP) ---------- */
  function bindQty(scope) {
    $$('.qty', scope).forEach(function (q) {
      if (q.dataset.bound) return; q.dataset.bound = '1';
      var input = $('input', q);
      $$('button', q).forEach(function (b) {
        b.addEventListener('click', function () {
          var v = parseInt(input.value || '1', 10) + (b.dataset.dir === 'up' || b.dataset.qty === 'up' ? 1 : -1);
          var min = parseInt(input.min || '1', 10), max = parseInt(input.max || '99', 10);
          input.value = Math.min(max, Math.max(min, v));
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }
  bindQty(document);

  /* ---------- gallery thumbs ---------- */
  var main = $('#pdpMain');
  $$('.pdp2-thumbs button').forEach(function (t) {
    t.addEventListener('click', function () {
      if (!main) return;
      if (t.dataset.srcset) { main.srcset = t.dataset.srcset; } else { main.removeAttribute('srcset'); }
      main.src = t.dataset.full; main.alt = t.dataset.alt || '';
      var imageLink = $('[data-image-open]'); if (imageLink) imageLink.href = t.dataset.zoom || t.dataset.full;
      $$('.pdp2-thumbs button').forEach(function (x) { x.setAttribute('aria-pressed', x === t ? 'true' : 'false'); });
      $$('.pdp2-thumbs button').forEach(function (x) { x.classList.remove('on'); });
      t.classList.add('on');
    });
  });

  /* Image inspection: native dialog provides keyboard focus containment and Escape. */
  var imageOpen = $('[data-image-open]'), imageDialog = $('[data-image-dialog]');
  if (main && imageOpen && imageDialog && typeof imageDialog.showModal === 'function') {
    imageOpen.addEventListener('click', function (e) {
      e.preventDefault();
      var large = $('[data-image-large]', imageDialog);
      large.src = imageOpen.href; large.alt = main.alt;
      imageDialog.showModal();
    });
    $('[data-image-close]', imageDialog).addEventListener('click', function () { imageDialog.close(); });
    imageDialog.addEventListener('click', function (e) {
      if (e.target === imageDialog) {
        var box = imageDialog.getBoundingClientRect();
        if (e.clientX < box.left || e.clientX > box.right || e.clientY < box.top || e.clientY > box.bottom) imageDialog.close();
      }
    });
    imageDialog.addEventListener('close', function () { imageOpen.focus(); });
  }

  /* ---------- plan selector → price on button + sticky ---------- */
  var form = $('[data-pdp-form]'), addBusy = false;
  function selectedPlan() { return $('input[name="selling_plan"]:checked, input[name="offer"]:checked', form); }
  function syncPlan() {
    if (!form) return;
    var p = selectedPlan(); if (!p) return;
    $$('.pdp2-plan', form).forEach(function (l) { l.classList.toggle('on', $('input', l) === p); });
    if (p.name === 'offer') {
      var idIn = $('[data-offer-id]', form), planIn = $('[data-offer-plan]', form), atcText = $('.atc-text', form);
      if (idIn && p.dataset.variant) idIn.value = p.dataset.variant;
      if (planIn) { planIn.value = p.dataset.plan || ''; planIn.disabled = !p.dataset.plan; }
      var needsPlan = p.dataset.requiresPlan === '1' && !p.dataset.plan;
      form.dataset.navigate = needsPlan ? (p.dataset.url || '') : '';
      if (atcText) atcText.textContent = needsPlan ? 'Choose subscription' : (form.dataset.preorder === 'true' ? 'Pre-order' : 'Add to bag');
    }
    var price = p.dataset.price, per = p.dataset.per, suffix = p.dataset.suffix || '';
    var atcPrice = $('[data-atc-price]', form); if (atcPrice) atcPrice.textContent = price + suffix;
    var summaryPrice = $('[data-summary-price]'), summaryOption = $('[data-summary-option]');
    if (summaryPrice) summaryPrice.textContent = price + suffix;
    if (summaryOption) summaryOption.textContent = (p.dataset.pouches ? p.dataset.pouches + ' pouches' : 'Selected option') + (suffix ? ' per renewal' : ' · one-time purchase');
    var sp = $('[data-sticky-price]'), spr = $('[data-sticky-per]'), sl = $('[data-sticky-label]');
    if (sp) sp.textContent = price + suffix; if (spr) spr.textContent = per;
    if (sl && p.dataset.label) sl.textContent = p.dataset.label;
    var available = p.dataset.available !== 'false';
    $$('[data-atc], [data-sticky-add]').forEach(function (button) { button.disabled = !available || addBusy; });
  }
  if (form) {
    $$('input[name="selling_plan"], input[name="offer"], input[name="id"]', form).forEach(function (i) { i.addEventListener('change', syncPlan); });
    syncPlan();
  }

  /* ---------- sticky buy bar ---------- */
  var sticky = $('[data-sticky]'), atc = $('[data-atc]');
  if (sticky && atc && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (es) {
      var visible = es[0].isIntersecting || window.scrollY < 180;
      sticky.classList.toggle('show', !visible);
      sticky.setAttribute('aria-hidden', visible ? 'true' : 'false');
      sticky.inert = visible;
    }, { threshold: 0 }).observe(atc);
    var stickyTicking = false;
    addEventListener('scroll', function () {
      if (stickyTicking) return; stickyTicking = true;
      requestAnimationFrame(function () {
        stickyTicking = false;
        var rect = atc.getBoundingClientRect();
        var visible = (rect.top < innerHeight && rect.bottom > 0) || scrollY < 180;
        sticky.classList.toggle('show', !visible);
        sticky.setAttribute('aria-hidden', String(visible)); sticky.inert = visible;
      });
    }, { passive: true });
    var stickyAdd = $('[data-sticky-add]', sticky);
    if (stickyAdd) stickyAdd.addEventListener('click', function () { form.requestSubmit ? form.requestSubmit() : atc.click(); });
  }
  var top = $('[data-scroll-top]');
  if (top) top.addEventListener('click', function (e) { e.preventDefault(); window.scrollTo({ top: 0, behavior: scrollBehavior() }); });

  /* ---------- cart drawer ---------- */
  var drawer = $('[data-drawer]');
  function openDrawer(opener) { if (!drawer) return; drawer.inert = false; drawer.classList.add('open'); drawer.setAttribute('aria-hidden', 'false'); document.body.classList.add('drawer-open'); window.kipModal.open(drawer, opener); }
  function closeDrawer() { if (!drawer) return; window.kipModal.close(drawer); drawer.classList.remove('open'); drawer.setAttribute('aria-hidden', 'true'); drawer.inert = true; document.body.classList.remove('drawer-open'); }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-drawer-open]')) { e.preventDefault(); openDrawer(); }
    if (e.target.closest('[data-drawer-close]')) { e.preventDefault(); closeDrawer(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  function fetchJSON(url, opts) {
    opts = opts || {}; opts.headers = Object.assign({ 'Accept': 'application/json' }, opts.headers || {});
    return fetch(url, opts).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  function rerenderDrawer() {
    return fetch(routes.root + '?sections=kip-cart-drawer').then(function (r) { return r.json(); }).then(function (j) {
      var html = j['kip-cart-drawer']; if (!html || !drawer) throw new Error('Bag preview unavailable');
      var tmp = document.createElement('div'); tmp.innerHTML = html;
      var fresh = $('[data-drawer]', tmp); if (!fresh) throw new Error('Bag preview unavailable');
      var wasOpen = drawer.classList.contains('open');
      var focused = document.activeElement, line = focused.closest('[data-line]');
      var focusKey = line && line.dataset.key, focusKind = focused.matches('input') ? 'input' : (focused.dataset.qty || (focused.hasAttribute('data-remove') ? 'remove' : ''));
      drawer.innerHTML = fresh.innerHTML;
      if (wasOpen) { drawer.classList.add('open'); drawer.setAttribute('aria-hidden', 'false'); }
      bindQty(drawer); bindLines(drawer);
      if (wasOpen) {
        var targetLine = $$('[data-line]', drawer).find(function (el) { return el.dataset.key === focusKey; });
        var target = targetLine && (focusKind === 'input' ? $('input', targetLine) : focusKind === 'remove' ? $('[data-remove]', targetLine) : $('[data-qty="' + focusKind + '"]', targetLine));
        (target || $('.drawer-x', drawer)).focus();
      }
      return fetchJSON(routes.cart + '.js');
    }).then(function (cart) { if (cart) syncCount(cart); });
  }
  function syncCount(cart) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
    $$('[data-cart-total]').forEach(function (el) { el.textContent = formatMoney(cart.total_price); });
  }
  function formatMoney(cents) {
    var fmt = (window.kip && window.kip.moneyFormat) || '£{{amount}}';
    var v = (cents / 100).toFixed(2);
    return fmt.replace(/\{\{\s*amount[^}]*\}\}/, v).replace(/<[^>]+>/g, '');
  }

  /* add to bag */
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (form.dataset.navigate) { location.href = form.dataset.navigate; return; }
      var btn = $('[data-atc]', form), err = $('[data-atc-error]', form);
      if (btn.disabled || offerBusy || addBusy) return;
      addBusy = true;
      var submitOpener = document.activeElement;
      var status = $('[data-atc-status]', form), recovery = $('[data-atc-recovery]', form);
      var stickyButton = $('[data-sticky-add]'), stickyLabel = stickyButton && stickyButton.textContent;
      var added = false;
      btn.classList.add('loading'); btn.disabled = true; btn.setAttribute('aria-busy', 'true');
      if (status) status.textContent = status.dataset.adding;
      if (stickyButton) {
        stickyButton.disabled = true; stickyButton.setAttribute('aria-busy', 'true');
        stickyButton.textContent = status ? status.dataset.adding : 'Adding…';
      }
      if (err) { err.hidden = true; err.textContent = ''; }
      if (recovery) recovery.hidden = true;
      var fd = new FormData(form);
      fetchJSON(routes.add + '.js', { method: 'POST', body: fd })
        .then(function () { added = true; return rerenderDrawer(); })
        .then(function () { openDrawer(submitOpener); })
        .catch(function (j) {
          if (!err) return;
          var message = added ? (status && status.dataset.addedRefreshFailed) :
            (j && j.description) || (status && status.dataset.unconfirmed);
          err.textContent = message || 'Check your bag before trying again.'; err.hidden = false;
          if (recovery) recovery.hidden = false;
          err.focus({ preventScroll: true });
          err.scrollIntoView({ block: 'center', behavior: scrollBehavior() });
        })
        .finally(function () {
          addBusy = false;
          btn.classList.remove('loading'); btn.removeAttribute('aria-busy');
          if (status) status.textContent = '';
          if (stickyButton) { stickyButton.textContent = stickyLabel; stickyButton.removeAttribute('aria-busy'); }
          syncPlan();
          if (!selectedPlan()) { btn.disabled = false; if (stickyButton) stickyButton.disabled = false; }
        });
    });
  }

  /* line changes: qty stepper / input / remove / upsell */
  var changes = Promise.resolve();
  var offerBusy = false;
  document.addEventListener('submit', function (e) {
    if (offerBusy && e.target.matches('#cartForm, #drawerForm, [data-pdp-form]')) e.preventDefault();
  }, true);
  function eligibleSwitch(cart, button, product) {
    var line = cart.items && cart.items[0];
    var variant = product.variants && product.variants.find(function (v) { return String(v.id) === button.dataset.target; });
    return cart.items.length === 1 && cart.total_discount === 0 && line &&
      line.key === button.dataset.key && line.handle === 'kip-wind-down-pouch-quiet-mint' &&
      line.quantity === Number(button.dataset.quantity) && line.quantity >= 1 && line.quantity <= 3 &&
      line.final_line_price === Number(button.dataset.sourceTotal) && !line.selling_plan_allocation &&
      Object.keys(line.properties || {}).length === 0 && product.handle === 'kip-wind-down-pouch-three-tins' &&
      product.variants.length === 1 && !product.requires_selling_plan && variant && variant.available &&
      variant.price === Number(button.dataset.targetPrice) && !(variant.selling_plan_allocations || []).length &&
      (!variant.quantity_rule || (variant.quantity_rule.min === 1 && variant.quantity_rule.increment === 1)) &&
      (line.quantity < 3 || variant.price < line.final_line_price);
  }
  function switchBundle(button) {
    if (offerBusy) return;
    offerBusy = true;
    cartError('');
    var controls = $$('[data-cart-switch], [data-line] button, [data-qty-input], [name="checkout"], [data-atc], [data-sticky-add]');
    var states = controls.map(function (c) { return c.disabled; });
    controls.forEach(function (c) { c.disabled = true; });
    var label = button.textContent;
    button.textContent = button.dataset.working;
    changes = changes.then(function () {
      return Promise.all([fetchJSON(routes.cart + '.js'), fetchJSON(button.dataset.targetUrl)]);
    }).then(function (data) {
      if (!eligibleSwitch(data[0], button, data[1])) throw new Error(button.dataset.changed);
      var updates = {};
      updates[data[0].items[0].key] = 0;
      updates[button.dataset.target] = 1;
      return fetchJSON(routes.cart + '/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: updates })
      });
    }).then(function (cart) {
      if (cart.items.length !== 1 || String(cart.items[0].variant_id) !== button.dataset.target ||
          cart.items[0].quantity !== 1 || cart.items[0].selling_plan_allocation) throw new Error(button.dataset.error);
      syncCount(cart);
      if ($('[data-cart-page]')) { location.reload(); return; }
      return rerenderDrawer();
    }).catch(function (error) {
      // An interrupted response can still have changed the server cart. Never retry a mutation automatically.
      if ($('[data-cart-page]')) {
        try { sessionStorage.setItem('kipCartOfferError', error.message === button.dataset.changed ? button.dataset.changed : button.dataset.error); } catch (ignored) {}
        location.reload(); return;
      }
      return rerenderDrawer().catch(function () {}).then(function () {
        cartError(error.message === button.dataset.changed ? button.dataset.changed : button.dataset.error);
      });
    }).finally(function () {
      offerBusy = false;
      controls.forEach(function (c, i) { if (c.isConnected) c.disabled = states[i]; });
      if (button.isConnected) button.textContent = label;
    });
  }

  function cartError(message) {
    $$('[data-cart-error]').forEach(function (el) { el.textContent = message; el.hidden = !message; });
  }
  function changeLine(key, qty) {
    if (offerBusy) return Promise.resolve();
    if (!Number.isInteger(qty) || qty < 0) { cartError('Enter a whole number of tins, zero or more.'); return Promise.resolve(); }
    changes = changes.then(function () {
      cartError('');
      $$('[data-line]').forEach(function (el) { el.setAttribute('aria-busy', 'true'); });
      return fetchJSON(routes.change + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
        .then(function () { return rerenderDrawer(); })
        .then(function () { if ($('[data-cart-page]')) location.reload(); })
        .catch(function () {
          // Show the last server-confirmed quantity, not the rejected input.
          $$('[data-line]').forEach(function (el) { var input = $('[data-qty-input]', el); if (input) input.value = input.defaultValue; });
          cartError('Your bag could not be updated. Check your connection and try again.');
        })
        .finally(function () { $$('[data-line]').forEach(function (el) { el.removeAttribute('aria-busy'); }); });
    });
    return changes;
  }
  function bindLines(scope) {
    $$('[data-cart-switch]', scope).forEach(function (button) {
      if (button.dataset.bound) return;
      button.dataset.bound = '1'; button.hidden = false;
      button.addEventListener('click', function () { switchBundle(button); });
    });
    $$('[data-line]', scope).forEach(function (line) {
      if (line.dataset.bound) return; line.dataset.bound = '1';
      var key = line.dataset.key, input = $('[data-qty-input]', line);
      var t;
      input.addEventListener('change', function () { clearTimeout(t); t = setTimeout(function () { changeLine(key, parseInt(input.value || '0', 10)); }, 250); });
      var rm = $('[data-remove]', line);
      if (rm) rm.addEventListener('click', function (e) { e.preventDefault(); changeLine(key, 0); });
    });
    $$('[data-upsell-add]', scope).forEach(function (b) {
      if (b.dataset.bound) return; b.dataset.bound = '1';
      b.addEventListener('click', function () {
        b.disabled = true;
        fetchJSON(routes.add + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: parseInt(b.dataset.upsellAdd, 10), quantity: 1 }) })
          .then(function () { return rerenderDrawer(); })
          .then(function () { if ($('[data-cart-page]')) location.reload(); else openDrawer(); })
          .catch(function () { b.disabled = false; cartError('Could not add that item. Please try again.'); });
      });
    });
  }
  bindLines(document);
  if ($('[data-cart-page]')) {
    try {
      var offerError = sessionStorage.getItem('kipCartOfferError');
      if (offerError) { cartError(offerError); sessionStorage.removeItem('kipCartOfferError'); }
    } catch (ignored) {}
  }
})();
